import { AppInjector } from 'app/app.module';
import { SetDefaultRecipientRoleFieldService } from 'app/global/set-default-recipient-role-field.service';
import { createBaseField } from './field-base';
import { Field } from './fields';

export function createDefaultRecipientRoleFieldBase(field: Field, setDefault: boolean = false) {
    const setDefaultRecipientRoleFieldService = AppInjector.get(SetDefaultRecipientRoleFieldService);
    const defaultRoleField = setDefaultRecipientRoleFieldService.setDefaultRecipientRoleField(field.uuid, setDefault);
    return {
        ...createBaseField(field),
        ...defaultRoleField
    };
}